// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"aec91479cdc2103f5668","293":"c813dd2f9f766c5d929b","518":"525f61c28980cb09283a","779":"7adc277ab673e66f202f"}[chunkId] + ".js";
};